import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { useState } from "react";
import SearchBar from "../../components/SearchBar";
import AddGroup from "../../Modals/addGroup";
import {
    Box,
    Button,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,

} from "@mui/material";
const Groups = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const handleCloseModal = () => {
        setOpenModal2(false);
    };
    const [openModal2, setOpenModal2] = useState(false);
    return (
        <><MainContainer>
            <div className="main_title">
                <h1>Manage CMS</h1>

            </div>
            <div className="cards">
                <div className="table_header">
                    <div className="left_s">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search..." />
                    </div>
                    <div className="right_s">
                        <Button
                            className="btn btn_primary"
                            onClick={() => {
                                setIsEdit(false);
                                setOpenModal2(true);
                            }}
                        >
                            Add Group
                        </Button>
                    </div>
                </div>
                <TableContainer className="table_container">
                    <Box className="heading"></Box>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Sr.no</TableCell>
                                <TableCell>Title</TableCell>
                                <TableCell>No. of Members</TableCell>
                                <TableCell>Date</TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {[1, 2, 3, 4, 5].map((index) => (
                                <TableRow key={index}>
                                    <TableCell>{index}</TableCell>
                                    <TableCell>
                                        <p
                                            className="cursor_p"
                                            onClick={() => navigate("/manage-cms/viewGroup")}
                                        >
                                            Group title here
                                        </p>
                                    </TableCell>
                                    <TableCell>{Math.floor(Math.random() * 50) + 1}</TableCell>{" "}
                                    {/* Example member count */}
                                    <TableCell>12 Jan 2024</TableCell>
                                    <TableCell>
                                        <div className="table_actions v2">
                                            <IconButton>
                                                <img src="/static/images/trash2_icon.svg" alt="" />
                                            </IconButton>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </MainContainer><AddGroup
                open={openModal2}
                onClose={handleCloseModal}
                setOpen={setOpenModal2} /></>
    );
}
export default Groups;
